import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvField, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();
    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            positionOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            positionBknFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_bkn_id',
                    order: 'asc' 
                }
            }
        }
    }

    submitData = async () => {
        await this.createBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadPosition = async () => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1
        }
        await this.createBloc.fetchPosition(query)
    }

    loadPositionBkn = async () => {
        let offset = (this.state.positionBknFilter.page_number-1)*this.state.positionBknFilter.page_size
        const query = {
            search: this.state.positionBknFilter.filter_value,
            limit: this.state.positionBknFilter.page_size,
            offset: offset,
            order: this.state.positionBknFilter.sort_order.column,
            sort: this.state.positionBknFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchPositionBkn(query);
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.positionFilter.filter_value = value

        this.timer = setTimeout(() => this.loadPosition(), 800);
    }

    handleSelectBknInputChange = value => {
        clearTimeout(this.timer)

        this.state.positionBknFilter.filter_value = value

        this.timer = setTimeout(() => this.loadPosition(), 800);
    }



    componentDidMount() {
        this.loadDetail()
        this.loadPosition()
        this.loadPositionBkn()

        this.createBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })       

        this.createBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.positionBknChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionBknOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default: 
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.createBloc.positionChannel?.unsubscribe()
        this.createBloc.positionBknChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/mapping-jabatan-bkn.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Mapping Jabatan Bkn</CardTitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <AvField name="position_mapping_bkn_uuid" value={detail?.position_mapping_bkn_uuid} type="hidden" />
                                <Row className="mb-3">
                                    <label
                                        htmlFor="rank_name"
                                        className="col-md-2 col-form-label"
                                    >
                                    Jabatan <span className="text-danger">*</span>
                                    </label>
                                    <Col md="3">
                                        { detail ? 
                                            <Select
                                                name="position_mapping_bkn_position_uuid"
                                                placeholder="Pilih Jabatan..."
                                                errorMessage="Pilih Jabatan"
                                                className="form-control"
                                                defaultValue={detail?.position_mapping_bkn_position_uuid}
                                                validate={{ required: { value: true } }}
                                                options={this.state.positionOption}
                                                optionLabel="position_name"
                                                optionValue="position_uuid"
                                                onInputChange={(e) => this.handleSelectInputChange(e)}
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>


                                <Row className="mb-3">
                                    <label
                                        htmlFor="rank_name"
                                        className="col-md-2 col-form-label"
                                    >
                                    E-Formasi <span className="text-danger">*</span>
                                    </label>
                                    <Col md="3">
                                        { detail ? 
                                            <Select
                                                name="position_mapping_bkn_position_bkn_uuid"
                                                placeholder="E-Formasi..."
                                                errorMessage="Pilih Jabatan Bkn"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                defaultValue={detail?.position_mapping_bkn_position_bkn_uuid}
                                                options={this.state.positionBknOption}
                                                optionLabel="position_bkn_name"
                                                optionValue="position_bkn_uuid"
                                                onInputChange={(e) => this.handleSelectBknInputChange(e)}
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="rank_group_code"
                                        className="col-md-2 col-form-label"
                                    >
                                    Analisis Beban Kerja <span className="text-danger">*</span>
                                    </label>
                                    <Col md="2">
                                        { detail ? 
                                            <AvField
                                                name="position_mapping_bkn_quota"
                                                placeholder="Analisis Beban Kerja..."
                                                type="number"
                                                errorMessage="Masukkan Analisis Beban Kerja"
                                                className="form-control"
                                                value={detail?.position_mapping_bkn_quota}
                                                validate={{ required: { value: true } }}
                                                id="rank_group_code"
                                            />
                                            :
                                            <Shimmer>
                                                <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                            marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="3"></Col>
                                    <Col md="9">
                                        <Link to="?">
                                            <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                        </Link>
                                        {' '}
                                        <Button color="danger" type="submit">
                                            <i className="uil-arrow-up-right"></i> Simpan Data
                                        </Button>
                                    </Col>
                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>

                </Container>
                 <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/mapping-jabatan-bkn.html?'/>
                : null }              
            </Fragment>
        )
    }

}

export default IndexView